// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { EmailNotificationsState } from "./types";

type SetShowEditModalRequest = $Exact<{
  show: boolean,
  step: number,
}>;

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get Email Notifications

export const onGetEmailNotifications = (state: EmailNotificationsState) => () =>
  startRequest(state);

export const onGetEmailNotificationsSuccess = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetEmailNotificationsError = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetEmailNotification = (state: EmailNotificationsState) => () => startRequest(state);

export const onGetEmailNotificationSuccess = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetEmailNotificationError = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetEmailNotificationAssignments = (state: EmailNotificationsState) => () =>
  startRequest(state);

export const onGetEmailNotificationAssignmentsSuccess = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  assignments: payload,
});

export const onGetEmailNotificationAssignmentsError = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Email Notifications Schema

export const onGetEmailNotificationSchema = (state: EmailNotificationsState) => () =>
  startRequest(state);

export const onGetEmailNotificationSchemaSuccess = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetEmailNotificationSchemaError = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create Email Notifications

export const onSetCurrentEmailNotification = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  current: payload,
});

export const onSetEditedEmailNotification = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  edited: payload,
});

export const onSetEmailNotificationAssignments = (state: EmailNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  assignments: payload,
});

// Modals

export const onSetShowAddModal = (state: EmailNotificationsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: EmailNotificationsState) => ({
  payload,
}: Action<SetShowEditModalRequest>) => {
  if (!payload) {
    return state;
  }

  return {
    ...state,
    modals: {
      ...state.modals,
      showEditModal: payload.show,
      modalStep: payload.step || state.modals.modalStep,
    },
  };
};

export const onSetShowDeleteModal = (state: EmailNotificationsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteModal: payload,
  },
});

export const onUpdateEmailNotification = (state: EmailNotificationsState) => ({
  payload,
}: Object) => startRequest(state);
export const onUpdateEmailNotificationSuccess = (state: EmailNotificationsState) => () =>
  finishRequest(state);
export const onUpdateEmailNotificationError = (state: EmailNotificationsState) => () =>
  finishRequest(state);
